import React from 'react';
import { Link } from 'react-router-dom';


$(".pagetitle").html("Appointment");


const AppointmentHome = () => (
  <div>
    <section className="hero">
      <div className="container">
        <h1>Care You Can Trust</h1>
        <p>Expert medical professionals dedicated to your family's health.</p>
        <Link to="/signup" className="btn-blue" style={{ fontSize: '18px', padding: '15px 30px', display: 'inline-block', marginTop: '20px' }}>
          Book Appointment &gt;&gt;
        </Link>
      </div>
    </section>

    <section id="facilities" className="section container">
      <h2 style={{ color: '#007bff' }}>Our Facilities</h2>
      <p>Modern labs, 24/7 Pharmacy, and state-of-the-art diagnostic imaging.</p>
    </section>

    <section id="services" className="section" style={{ background: '#f8fafc' }}>
      <div className="container">
        <h2 style={{ color: '#007bff' }}>Services</h2>
        <ul>
          <li>General Checkups</li>
          <li>Pediatric Care</li>
          <li>Cardiology</li>
        </ul>
      </div>
    </section>

    <section id="contact" className="section container">
      <h2 style={{ color: '#007bff' }}>Contact Us</h2>
      <p>123 Health Ave, Baner, Pune | +91 99999 99999</p>
    </section>
  </div>
);

export default AppointmentHome;